import React, { useEffect, useRef } from "react";
import { LiveChatStyles as styles } from "./chat.tailwind";
import CommentaryMessage from "./CommentaryMessage";
import no_activity from '../../../../../../assets/svgs/no_activity.svg';
// import { LIVE_GAME_CHAT_CONTENT_TYPE } from "../../../../../../lib/constants/globalConstant";
import { useSelector } from "react-redux";
import CommentarySkeleton from "./Skeleton/CommentarySkeleton/CommentarySkeleton";

const Commentary = ({ replayedMessage, handleReplayCommentary  }) => {
  const commentaryMessagesRef = useRef(null);
  const { liveGameActions, fetchingLiveActions } = useSelector((state) => state.scorer);
  // const commentaryMessages = messages?.filter((message) => message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.COMMENTARY) || [];

  useEffect(() => {
    // Scroll to the bottom whenever messages change    
    if (commentaryMessagesRef.current && !replayedMessage) {        
      commentaryMessagesRef.current.scrollTop = commentaryMessagesRef.current.scrollHeight;
    }
  }, [liveGameActions, replayedMessage]);

  if(fetchingLiveActions) {
    return (
      <div className={styles.commentaryContainer}>
        <CommentarySkeleton count={5}/>
      </div>
    )
  }

  if(liveGameActions?.length === 0) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center gap-2">
        <img src={no_activity} alt="no-activity" className={styles.noactivity} />
        <p className={styles.activity_text}>No Activity Right Now!</p>
      </div>
    )
  }

  return (
    <div className="h-full w-full flex flex-col gap-1">
      <h1 className='text-[14px] font-[300]  p-1 screen-500:hidden'>Commentary</h1>
      <div className={styles.commentaryContainer} ref={commentaryMessagesRef}>
        {liveGameActions?.map((message, index) => (
          <CommentaryMessage
            key={index}
            message={{
              messageText: message?.actionDescription,
              additionalComments: message?.additionalComments,
              player1Zone: message?.player1Zone,
              player2Zone: message?.player2Zone,
              replayText: message?.replayText,
              homeTeamScore: message?.homeTeamScore,
              awayTeamScore: message?.awayTeamScore,
              selectedActionImageofPlayers: message?.selectedActionImageofPlayers
            }}
            fullWidth={true}
            handleReplayCommentary={handleReplayCommentary}
          />
        ))}
      </div>
    </div>
  );
};

export default Commentary;
